module.exports = __webpack_public_path__ + "media/icons/car-ef01df3a.svg";